import { Colour, Notes_BehaviourType } from '@tyro/api';

export const behaviourColorByType = new Map<Notes_BehaviourType, Colour>([
  [Notes_BehaviourType.Positive, Colour.Green],
  [Notes_BehaviourType.Negative, Colour.Rose],
  [Notes_BehaviourType.Neutral, Colour.Blue],
]);
